import { render, staticRenderFns } from "./User-contact-information.vue?vue&type=template&id=775da2ea&scoped=true"
import script from "./User-contact-information.vue?vue&type=script&lang=js"
export * from "./User-contact-information.vue?vue&type=script&lang=js"
import style0 from "./User-contact-information.vue?vue&type=style&index=0&id=775da2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775da2ea",
  null
  
)

export default component.exports